<div class="listingActionPopover">
	<ion-list lines="none">
		<ion-item lines="none" class="link" (click)="copy()" *ngIf="options.copy === true" data-cy="listingAction-copy">
			<label class="link"><ion-icon name="copy-outline"></ion-icon> Copy</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="view()" *ngIf="options.view === true" data-cy="listingAction-view">
			<label class="link"><ion-icon name="link-outline"></ion-icon> View</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="shareMicrosite()" *ngIf="options.shareMicrosite === true"
			data-cy="listingAction-share">
			<label class="link"
				[ngClass]="{'linkDisabled' : !listing.webPublished, 'linkEnabled': listing.webPublished}"><ion-icon
					class="cpy-lnk pc-lnk mob-cpy" name="share-social-outline"></ion-icon> Share</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="edit()" *ngIf="options.edit === true"
			data-cy="listingAction-editListing"
			[ngClass]="{'linkDisabled': ((role === 'lender') && editListing) , 'linkDisabled': ((role === 'lender' ) && !editListing)}">
			<label class="link"><ion-icon name="pencil-outline"></ion-icon> Edit Listing</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="launch()" *ngIf="options.launch === true && role !== 'agentAdmin'"
			data-cy="listingAction-launchOpenHouseSignIn"
			[ngClass]="{'linkDisabled' : role === 'lender' , 'linkEnabled': role === 'agent'}">
			<label class="link"><ion-icon name="rocket-outline"></ion-icon> Launch Open House Sign-in</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="link()" *ngIf="options.link === true"
			data-cy="listingAction-shareListing">
			<label [ngClass]="{'linkDisabled' : !listing.webPublished, 'linkEnabled': listing.webPublished}" class="link">
				<ion-icon name="link-outline"></ion-icon> View
				Microsite</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="save()" *ngIf="options.save === true"
			data-cy="listingAction-saveListingQrCode">
			<label [ngClass]="{'linkDisabled' : !listing.webPublished, 'linkEnabled': listing.webPublished}" class="link">
				<ion-icon class="cpy-lnk pc-lnk mob-cpy" name="qr-code-outline"></ion-icon> View/Save QR Code</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="scheduler()" *ngIf="options.scheduler === true && role === 'agentAdmin'"
			data-cy="listingAction-openScheduler">
			<label
				[ngClass]="{'linkDisabled' : listing?.listingDetails?.saleStatus === 'inactive', 'linkEnabled': listing?.listingDetails?.saleStatus !== 'inactive'}"
				class="link">
				<ion-icon class="cpy-lnk pc-lnk mob-cpy" name="calendar-outline"></ion-icon> Open Scheduler</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="howDoIuseMyOnlylink()" *ngIf="options.howDoIuseMyOnlylink === true"
			data-cy="listingAction-useOnlylInk">
			<label class="link"><ion-icon name="information-circle-outline"></ion-icon> How do I use My Link ?</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="whatIsAMicrosite()" *ngIf="options.whatIsAMicrosite === true"
			data-cy="listingAction-Microsite">
			<label class="link"><ion-icon name="information-circle-outline"></ion-icon> What is a Microsite?</label>
		</ion-item>

		<ion-item lines="none" class="link" (click)="share()" *ngIf="options.share === true"
			data-cy="listingAction-shareListing">
			<label [ngClass]="{'linkDisabled' : !listing.webPublished, 'linkEnabled': listing.webPublished}"
				class="link"><ion-icon class="cpy-lnk pc-lnk mob-cpy" name="share-social-outline"></ion-icon> Share
				Listing</label>
		</ion-item>
		<!-- <ion-item lines="none" class="link" (click)="create()"
			*ngIf="listing.webPublished === false && options.create === true" data-cy="listingAction-createListingMicrosite">
			<label class="link">Create Listing Microsite</label>
		</ion-item> -->
		<ion-item lines="none" class="link" (click)="sync()" *ngIf="listing.slug && options.sync === true"
			data-cy="listingAction-manuallySyncChanges">
			<label class="link"><ion-icon name="sync-outline"></ion-icon> Manually Sync Changes</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="delete()" *ngIf="options.delete === true"
			data-cy="listingAction-deleteListing" [ngClass]="isPaired">
			<label class="link"><ion-icon name="trash-outline"></ion-icon> Delete Listing</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="close()" *ngIf="options.close === true" data-cy="listingAction-exit">
			<label class="link">Exit</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="restart()" *ngIf="options.restart === true"
			data-cy="listingAction-restart">
			<label class="link">Restart</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="skip()" *ngIf="options.skip === true"
			data-cy="listingAction-skipQuestion">
			<label class="link">Skip Question</label>
		</ion-item>
		<ion-item lines="none" class="link" (click)="addNotePrev()" *ngIf="options.addNotePrev === true"
			data-cy="listingAction-noteForPreviousGuest">
			<label class="link">Add note for previous guest</label>
		</ion-item>
	</ion-list>
</div>